/** EL LOGO DE UN CLIENTE (rebranding macOS 27, punto 11, 21-oct-2026): lo que se hace en el navegador antes de subirlo. */

/** Lo que se deja subir como logo (el servidor vuelve a mirar los bytes) y su tope. */
export const TIPOS_LOGO = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
const LOGO_MAX_BYTES = 512 * 1024;
const LADO_LOGO = 256;

/**
 * Deja el logo en un cuadrado de 256 px (PNG, con fondo transparente, sin recortar). Un SVG se
 * dibuja a través de <img> —que no corre su código— y sale como PNG: al servidor nunca llega un SVG.
 */
export async function reducirLogo(archivo: File): Promise<Blob> {
  const url = URL.createObjectURL(archivo);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    const ancho = img.naturalWidth || LADO_LOGO;
    const alto = img.naturalHeight || LADO_LOGO;
    const k = Math.min(LADO_LOGO / ancho, LADO_LOGO / alto);
    const lienzo = document.createElement('canvas');
    lienzo.width = lienzo.height = LADO_LOGO;
    const ctx = lienzo.getContext('2d');
    if (!ctx) throw new Error('El navegador no pudo preparar el logo');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, (LADO_LOGO - ancho * k) / 2, (LADO_LOGO - alto * k) / 2, ancho * k, alto * k);
    return await new Promise<Blob>((bien, mal) =>
      lienzo.toBlob((b) => (b ? bien(b) : mal(new Error('El navegador no pudo preparar el logo'))), 'image/png'),
    );
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** Por qué no sirve un archivo como logo, o null si sirve (tipo y tamaño). */
export function problemaDelLogo(archivo: { type: string; size: number }): string | null {
  if (!TIPOS_LOGO.includes(archivo.type)) return 'El logo debe ser PNG, JPG, WEBP o SVG.';
  if (archivo.size > LOGO_MAX_BYTES) return 'El logo pasa de 512 KB.';
  return null;
}
